var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('b-form-group',{attrs:{"label":_vm.Label}},[_c('b-form-radio-group',{attrs:{"options":_vm.Options,"name":_vm.Name,"disabled":_vm.isReadOnly,"checked":_vm.value,"stacked":_vm.Stacked},on:{"change":_vm.OnChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }